/**
 * 解析字符串为对象
 */
const parser = (str) => {
    let obj = {};
    str.replace(/([^&=]*)=([^&=]*)/g, function() {
      obj[arguments[1]] = arguments[2];
    });
    return obj;
}

// 把对象拼接
function pars(param, key, encode) {
  if (param == null) return '';
  var arr = [];
  var t = typeof (param);
  if (t == 'string' || t == 'number' || t == 'boolean') {
      arr.push(key + '=' + ((encode == null || encode) ? encodeURIComponent(param) : param));
  } else {
      for (var i in param) {
          var k = key == null ? i : key + (param instanceof Array ? '[' + i + ']' : '.' + i);
          arr.push(pars(param[i], k, encode));
      }
  }
  return arr.join("&");
}

const isEmptyObject = (obj) => {
  if (obj === null) return true
  if (obj === undefined) return true
  if (Object.keys(obj).length == 0) return true
  return false
}


/*函数节流*/
function throttle(fn, interval) {
  var enterTime = 0; // 触发的时间
  var gapTime = interval || 300; // 间隔时间，如果interval不传，则默认300ms
  return function() {
    var context = this;
    var backTime = new Date(); // 第一次函数return即触发的时间
    if (backTime - enterTime > gapTime) {
      fn.call(context, arguments);
      enterTime = backTime; // 赋值给第一次触发的时间，这样就保存了第二次触发的时间
    }
  };
}

/*函数防抖*/
function debounce(fn, interval) {
  var timer;
  var gapTime = interval || 1000; // 间隔时间，如果interval不传，则默认1000ms
  return function() {
    clearTimeout(timer);
    var context = this;
    var args = arguments; // 保存此处的arguments，因为setTimeout是全局的，arguments不是防抖函数需要的。
    timer = setTimeout(function() {
      fn.call(context, args);
    }, gapTime);
  };
}

export default {
    parser,
    pars,
    isEmptyObject,
    throttle,
    debounce
}